import { render, staticRenderFns } from "./AddAppliance.vue?vue&type=template&id=ef6a2cce&scoped=true"
import script from "./AddAppliance.vue?vue&type=script&lang=js"
export * from "./AddAppliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6a2cce",
  null
  
)

export default component.exports